import React from "react";
import { Link } from "react-router-dom";
import comingSoonBg from "../../assets/images/coming/comingSoonBg.jpg";
import "./ComingSoon.css";
import { Typewriter } from "react-simple-typewriter";

const ComingSoon = () => {
  return (
    <section
      className="flex items-center h-[74vh] p-16 bg-main text-gray-100 relative"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0, 0.9) 0%, rgba(0,0,0, 0.9) 100%), url(${comingSoonBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        width: "100%",
        height: "74vh",
      }}
    >
      <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-20 font-extrabold text-6xl text-white">
            <Typewriter
              words={["Coming Soon", "Coming Soon", "Coming Soon"]}
              loop={7}
              cursor
              cursorStyle="|"
              typeSpeed={200}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </h2>

          <Link
            to="/home"
            className="px-8 py-3 font-semibold rounded bg-secondary text-white cursor-pointer"
          >
            Back to homepage
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
